import {RootState} from '../../../redux/store';

export const getExportData = (state: RootState) => state.export;
